import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "qaP",
  "layout:fragment": "content"
}
const _hoisted_2 = { class: "sec-main qaP-main bg-gray" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "創業Q&A", -1)
const _hoisted_9 = { class: "row head-row mb-4" }
const _hoisted_10 = { class: "col-11 col-sm-10 mx-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", { class: "visually-hidden" }, "創業Q&A", -1)
const _hoisted_12 = { class: "fcss" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 text-primary mb-4" }, "創業Q&A", -1)
const _hoisted_14 = { class: "filter-tabs pt-md-2 pt-1" }
const _hoisted_15 = {
  class: "nav justify-content-center",
  id: "qa-tab",
  role: "tablist"
}
const _hoisted_16 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_17 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_18 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_19 = {
  class: "tab-content",
  id: "qa-tabContent"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-11 col-sm-10 mx-auto" }
const _hoisted_22 = { class: "list-unstyled qa-list" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-11 col-sm-10 mx-auto" }
const _hoisted_25 = { class: "list-unstyled qa-list" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-11 col-sm-10 mx-auto" }
const _hoisted_28 = { class: "list-unstyled qa-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(1))),
                      class: _normalizeClass([{active: _ctx.tab == 1}, "nav-link tab-underline"]),
                      id: "qa1-tab",
                      "data-bs-toggle": "pill",
                      "data-bs-target": "#qa1",
                      type: "button",
                      role: "tab",
                      "aria-controls": "qa1",
                      "aria-selected": "true"
                    }, "一般通識", 2)
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(2))),
                      class: _normalizeClass([{active: _ctx.tab == 2}, "nav-link tab-underline"]),
                      id: "qa2-tab",
                      "data-bs-toggle": "pill",
                      "data-bs-target": "#qa2",
                      type: "button",
                      role: "tab",
                      "aria-controls": "qa2",
                      "aria-selected": "false",
                      tabindex: "-1"
                    }, "創業資金", 2)
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(3))),
                      class: _normalizeClass([{active: _ctx.tab == 3}, "nav-link tab-underline"]),
                      id: "qa3-tab",
                      "data-bs-toggle": "pill",
                      "data-bs-target": "#qa3",
                      type: "button",
                      role: "tab",
                      "aria-controls": "qa3",
                      "aria-selected": "false",
                      tabindex: "-1"
                    }, "工商登記", 2)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: _normalizeClass([{active: _ctx.tab == 1, show: _ctx.tab == 1}, "tab-pane fade"]),
            id: "qa1",
            role: "tabpanel",
            "aria-labelledby": "qa1-tab",
            tabindex: "0"
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("ul", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type1_lists, (list) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "qa-item",
                      key: list.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: {name: 'qa-detail', params: {id: list.id}},
                        title: "創業Q&A",
                        class: "head-label"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(list.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{active: _ctx.tab == 2, show: _ctx.tab == 2}, "tab-pane fade"]),
            id: "qa2",
            role: "tabpanel",
            "aria-labelledby": "qa2-tab",
            tabindex: "0"
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("ul", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type2_lists, (list) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "qa-item",
                      key: list.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: {name: 'qa-detail', params: {id: list.id}},
                        title: "創業Q&A",
                        class: "head-label"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(list.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{active: _ctx.tab == 3, show: _ctx.tab == 3}, "tab-pane fade"]),
            id: "qa3",
            role: "tabpanel",
            "aria-labelledby": "qa3-tab",
            tabindex: "0"
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("ul", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type3_lists, (list) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "qa-item",
                      key: list.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: {name: 'qa-detail', params: {id: list.id}},
                        title: "創業Q&A",
                        class: "head-label"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(list.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 2)
        ])
      ])
    ])
  ])), [
    [_directive_title, '創業Q&A']
  ])
}